import { render, staticRenderFns } from "./PlateCreateOrUpdate.vue?vue&type=template&id=1852a655&"
import script from "./PlateCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./PlateCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports